import { useEffect, useMemo, useState } from "react";
import "./OnlineBooking.css";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import { UpdateTheme } from "./Requests";
import "react-toastify/dist/ReactToastify.css";
import { notifyError, notifySuccess } from "../../Response/ResposeHandler";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const Theme = (props) => {
  const { t, i18n } = useTranslation("bookingTheme");

  const [theme, setTheme] = useState(
    // keep initial selection using current config
    { value: props.config.themeId, label: "" }
  );
  const [saveThemeButtonLoading, setSaveThemeButtonLoading] = useState(false);

  // Localized theme options
  const themeOptions = useMemo(
    () => [
      { value: 1, label: t("theme.options.beige") },
      { value: 2, label: t("theme.options.whiteGrey") }
    ],
    [t, i18n.language]
  );

  // Keep the selected option in sync with language + incoming config
  useEffect(() => {
    const matched = themeOptions.find(o => o.value === props.config.themeId) || themeOptions[0];
    setTheme(matched);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.config.themeId, themeOptions]);

  function SaveTheme() {
    UpdateTheme(theme.value)
      .then(() => {
        notifySuccess(t("theme.toasts.saved"));
      })
      .catch(() => {
        notifyError(t("theme.toasts.saveError"));
      })
      .finally(() => {
        setSaveThemeButtonLoading(false);
        props.getSite();
      });
  }

  return (
    <div className="up-wrap">
      {/* <ToastContainer /> */}

      {/* Row: Theme chooser */}
      <section className="up-card">
        <div className="gen-cardHead">
          <h3 className="gen-h3">{t("theme.titles.chooseTheme")}</h3>
          <p className="gen-muted">
            {t("theme.subtitles.pickStyle")}
            <span className="sm-help">{t("theme.subtitles.appliesHint")}</span>
          </p>
        </div>

        <div className="up-field">
          <Select
            isSearchable={false}
            placeholder={t("theme.placeholders.selectTheme")}
            closeMenuOnSelect
            options={themeOptions}
            onChange={(e) => setTheme({ value: e.value, label: e.label })}
            value={theme}
            className="sm-select"
            classNamePrefix="rs"
          />
        </div>

        <div className="infoActions mt-3">
          <CustomButton
            disabled={saveThemeButtonLoading}
            className="app-btn--sm"
            onClick={SaveTheme}
            label={t("theme.actions.saveTheme")}
            loading={saveThemeButtonLoading}
          />
        </div>
      </section>
    </div>
  );
};

export default Theme;
